import { render, staticRenderFns } from "./TheCancelOrder.vue?vue&type=template&id=d2d61b36&scoped=true"
import script from "./TheCancelOrder.vue?vue&type=script&lang=js"
export * from "./TheCancelOrder.vue?vue&type=script&lang=js"
import style0 from "./TheCancelOrder.vue?vue&type=style&index=0&id=d2d61b36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2d61b36",
  null
  
)

export default component.exports